import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
    selector: 'app-book-issues',
    templateUrl: './book-issues.component.html',
    styleUrls: ['./book-issues.component.css']
})
export class BookIssuesComponent implements OnInit {

    Submitted: boolean = false;
    IsLosed=false;
    
    StaffStudentList:[];
    PaymentModeList = [];
    BookIssuedList = [];
    Student = [];
    ClassList = [];
    PersonTypeList = [];
    SectionList = [];
    EmployeeList = [];
    EmployeeCategoryList = [];
    EmployeeTypeList = [];
    AllBookIssuedList = [];
    LibCardNoAlert = '';
    BookFineID = 0;
    ReceiptNo = '';
    CardSearchloading = true;
    submit: boolean = false;
    BookAlert = '';
    List = [];   
    BookSerialNo = '';
    Count1 = 0;
    IsReturned = false;
    BookIssueList = []
    hidePrint = false;
    ItemList = [];
    Count=0;
    SelectAlert:any;
    BankList:[];
    Bank:[];
    

    constructor(private libraryservice: LibraryService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
        private spinnerService: Ng4LoadingSpinnerService) { }

    BookIssuesModel =
        {
            Remarks:'',
            PersonTypeID: 0,
            ClassID: 0,
            EmployeeCategoryID: 0,
            EmployeeTypeID: 0,
            SectionID: 0,
            PersonID: 0,
            BookTransactionID: 0,
            BookID: 0,
            BookSerialNo: 0,
            LibraryTypeID: 0,
            IsStaff: false,
            IsStudent: false,
            RequestStatus: 0,
            RequestByID: 0,
            BookTitle: 0,
            IsStudentStaff: 0,
            ID: 0,
            LibCardNo: '',
            IssuePeriod: 0,
            IsLosed: false,
            IsReturned: false,
            PaidAmount: 0,
            TotalDiscuntAmount: 0,
            TotalFineAmount: 0,
            BookStatusID:0,
            PaymentMode:''
        }


    GetReservedBook() {
        var itemBo = {
            'ItemCode1': this.BookIssuesModel.LibCardNo,
            'ItemName': this.BookIssuesModel.BookSerialNo,
        };
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('ReservedBook', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.Student = data.LookupItems;
            this.spinnerService.hide();
        });
    };

    GetClass() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
            this.ClassList = data.LookupItems;
            this.spinnerService.hide();
        });
    };


    GetPersonType() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('PersonType', '').subscribe((data: any) => {
            this.PersonTypeList = data.LookupItems;
            
            this.spinnerService.hide();
        });
    };

    GetSection() {
        this.BookIssuesModel.SectionID = 0;
        this.BookIssuesModel.PersonID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.BookIssuesModel.ClassID,

        };
        this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.SectionList = data.LookupItems;
            this.spinnerService.hide();
        });

    };


    GetStudent() {
        this.BookIssuesModel.PersonID = 0;
        var itemBo = {
            'ItemId': this.BookIssuesModel.ClassID,
            'ItemId2': this.BookIssuesModel.SectionID
        };
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.Student = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetEmployee() {
        var itemBo = {
            'ItemId': this.BookIssuesModel.EmployeeTypeID,
            'ItemId1': this.BookIssuesModel.EmployeeCategoryID
        };
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('EmployeeCode', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.EmployeeList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetLibCardNo() {
        
        var itemBo = {
            'ItemId': this.BookIssuesModel.PersonTypeID,
            'ItemId1': this.BookIssuesModel.PersonID
        };
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('LibCardNo', JSON.stringify(itemBo)).subscribe((data: any) => {

            if (data.LookupItems.length > 1) {                
                this.BookIssuesModel.LibCardNo = data.LookupItems[1].ItemName;
             

            }
            this.spinnerService.hide();
        });
    };

    GetEmployeeCategory() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
            this.EmployeeCategoryList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetEmployeeType() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
            this.EmployeeTypeList = data.LookupItems;
            this.spinnerService.hide();
        });
    };


    PersonDetailsList = {
        PersonID: 0,
        IssuePeriod: 0,
        ItemIssueLimit: 0,
        LibCardNo: '',
    }

    GetAllIssueDetails() {
        this.spinnerService.show();
        this.libraryservice.GetAllIssueDetails(this.BookIssuesModel.LibCardNo).subscribe((response: any) => {

            this.AllBookIssuedList = response.AllBookIssuedList;
            this.globalHelper.CheckActionStatus(response);
            this.spinnerService.hide();
        });
    }


    //filtertype - It is defined 0 or 1 . When clicked on  Find button it will be 0 in other cases it will be 1.
    SearchPersonDetails(filtertype) {

        if (filtertype == 0) {
            this.BookAlert = '';
            this.LibCardNoAlert = '';
            this.BookFineID = 0;
            this.ReceiptNo = '';
            this.CardSearchloading = true;

        }
        this.spinnerService.show();
        
        this.libraryservice.SearchPersonDetails(this.BookIssuesModel.LibCardNo).subscribe((response: any) => {
            this.spinnerService.hide();

            if (response.PersonDetailsList == null) {
                this.LibCardNoAlert = 'This Card No. not exits ';
            }

            if (response.PersonDetailsList.PersonTypeID == 2) {
                this.BookIssuesModel.PersonTypeID = response.PersonDetailsList.PersonTypeID.toString().trim();
                this.BookIssuesModel.ClassID = response.PersonDetailsList.ClassID;
                this.GetSection();

                this.BookIssuesModel.SectionID = response.PersonDetailsList.SectionID;

                this.GetStudent();

                this.BookIssuesModel.PersonID = response.PersonDetailsList.PersonID;

            }
            else if (response.PersonDetailsList.PersonTypeID == 1) {
                this.BookIssuesModel.PersonTypeID = response.PersonDetailsList.PersonTypeID.toString().trim();
                this.BookIssuesModel.EmployeeCategoryID = response.PersonDetailsList.EmployeeCategoryID.toString().trim();
                this.BookIssuesModel.EmployeeTypeID = response.PersonDetailsList.EmployeeTypeID.toString().trim();
                this.GetEmployee();
                this.BookIssuesModel.PersonID = response.PersonDetailsList.PersonID.toString().trim();
                this.BookIssuesModel.IssuePeriod = this.PersonDetailsList.IssuePeriod;

            }

            this.BookIssuesModel.IssuePeriod = response.PersonDetailsList.IssuePeriod;

            this.GetAllIssueDetails();

            this.PersonDetailsList = response.PersonDetailsList;

            if (this.PersonDetailsList == null)
                this.submit = true;
            if (this.PersonDetailsList != null)
                this.submit = false;

            this.BookIssuedList = response.BookIssuedList;
           
            

            this.GetTotal();
        

        });
    }



ChangeReturned(item) {

    this.IsReturned = false;
    this.Count1 = 0;
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].BookStatusID==5) {
            this.Count1 = this.Count1 + 1

        }
    }
    if (this.Count1 == this.BookIssuedList.length) {
        this.IsReturned = true;
    }
    else {
        this.IsReturned = false;
    }
    this.GetTotal();
}

SelectAllReturned() {
 if (this.IsReturned) {
        for (var i = 0; i < this.BookIssuedList.length; i++) {
            this.BookIssuedList[i].IsReturned = true;

        }
    }
    this.GetTotal();

}


SearchBookIssue() {
    
    this.BookAlert = '';
    if (this.PersonDetailsList.PersonID == 0) {
        this.BookAlert = 'please click find button'
        return;
    }

    if (this.BookIssuesModel.PersonID == 0) {
        this.BookAlert = 'please enter Card No'
        return;
    }
    if (this.BookSerialNo == '') {
        this.BookAlert = 'please enter Book No'
        return;
    }
    if ((this.BookIssuedList.length + this.ItemList.length) >= this.PersonDetailsList.ItemIssueLimit) {
        this.BookAlert = 'You can take maximum books' + '-' + this.PersonDetailsList.ItemIssueLimit;
        return;
    }

    this.spinnerService.show();
    this.libraryservice.SearchBookIssue(this.BookSerialNo, this.PersonDetailsList.LibCardNo).subscribe((response: any) => {

        this.spinnerService.hide();
        this.List = response.BookIssueList
        if (this.List == null || this.List.length == 0) {
            this.BookAlert = "This Acc No." + ' ' + this.BookSerialNo + " not exits ";
        }
        else {
           

            if (!this.List[0].IsIssuable) {
               
                this.BookAlert = " This Acc No. " + ' ' + this.BookSerialNo + ' ' + " is not issuable."
                }
                
            else if (this.List.length > 0 && this.List[0].LibCardNo && this.List[0].IsReserved) {
                this.BookAlert = " This Acc No. " + ' ' + this.BookSerialNo + ' ' + " is reserved for Lib Card No: " + ' ' + this.List[0].LibCardNo;
                
            }
            else if (this.List[0].BookStatusID == 3 || this.List[0].BookStatusID == 2)
             {
                
                this.BookAlert = ' This book is lost or damaged.';
            }
            else if (this.List[0].BookStatusID == 1) {
             
                this.BookIssueList = response.BookIssueList;
                this.Add();
            }
            else if (this.List[0].BookStatusID == 4) {
                if (this.List[0].PersonType == "Student") {
                    this.BookAlert = ' This book is already issued to ' + this.List[0].PersonType + ' ' + 'GR No' + ' ' + this.List[0].LibCardNo;
                }
                else {
                    this.BookAlert = ' This book is already issued to ' + this.List[0].PersonType + ' ' + ' Library Card No ' + ' ' + this.List[0].LibCardNo;
                }
            }
        }

        this.globalHelper.CheckActionStatus(response);
    });
}


Add() {
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].BookSerialNo == this.BookSerialNo) {
            this.BookAlert = 'Acc No  already entered';
            return;
        }
    }
    var itembo = {
        BookSerialNo: this.BookIssueList[0].BookSerialNo,
        BookID: this.BookIssueList[0].BookID,
        BookTitle: this.BookIssueList[0].BookTitle,
        AuthorName: this.BookIssueList[0].AuthorName,
        GroupName: this.BookIssueList[0].GroupName,
        BookEddition: this.BookIssueList[0].BookEddition,
        BookTransactionID: 0,
        IsReturned: false
    }
    this.BookIssuedList.push(itembo);
}

removeRow(index) {
    this.BookIssuedList.splice(index, 1);
};



PrintFineReceipt(PrintType) {
    this.hidePrint = false;
    var url = "../../../../App/LIB/BookFineReceipt/BookFineReceiptPrint.html?PrintType=FineReceipt&BookFineID=" + this.BookFineID + "&PrintType=" + PrintType + "&CopyType=" + 'O';
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
};


SaveBookReturn() {
    this.SelectAlert = '';
    this.Count = 0;
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].IsReturned) {
            this.Count = 1;
            break;
        }
    }
    if (this.Count == 1) {
        this.BookIssuesModel.IsLosed = false;
        this.BookIssuesModel.IsReturned = true;
        this.BookIssuesModel.BookStatusID = 5;

        this.spinnerService.show();
        this.libraryservice.SaveBookReturn(JSON.stringify(this.BookIssuesModel), JSON.stringify(this.BookIssuedList)).subscribe((response: any) => {
            this.globalHelper.CheckActionStatus(response);
            this.BookFineID = response.BookFineID;
            this.ReceiptNo = response.ReceiptNo;

            this.spinnerService.hide();
            if (response.webResponse.Status) {
                this.SearchPersonDetails(1);
            }
        })
    }
    else {
        this.SelectAlert = 'Please select at least one book ';
    }
}

SaveBookReturnLosed() {
    this.SelectAlert = '';
    this.Count = 0;
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].IsReturned) {
            this.Count = 1;
            break;
        }
    }
    if (this.Count == 1) {

        if (!confirm("Are you sure you want to submit without fine?"))
            return;


        var retVal = confirm("Are you sure you want to lost this book");
        if (retVal == true) {

            this.BookIssuesModel.IsLosed = true;
            this.BookIssuesModel.IsReturned = false;
            this.BookIssuesModel.BookStatusID = 3;
            
            this.spinnerService.show();
            this.libraryservice.SaveBookReturn(JSON.stringify(this.BookIssuesModel), JSON.stringify(this.BookIssuedList)).subscribe((response: any) => {
                this.globalHelper.CheckActionStatus(response);
                
                this.spinnerService.hide();
                if (response.webResponse.Status) {
                    this.SearchPersonDetails(1);
                }
            })


            return true;
        }
    }
    else {
        this.SelectAlert = 'Please select at least one book ';
    }

}



SaveBookRenew() {
    this.SelectAlert = '';
    this.BookIssuesModel.BookStatusID = 0;
    this.Count = 0;
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].IsReturned) {
            this.BookIssuesModel.BookStatusID = 5;
        }
        if (this.BookIssuedList[i].IsReturned || this.BookIssuedList[i].BookTransactionID == 0) {
            this.Count = 1;
            break;
        }
    }

    if (this.Count == 1) {
      
        this.spinnerService.show();
        this.libraryservice.SaveBookRenew(JSON.stringify(this.BookIssuesModel), JSON.stringify(this.BookIssuedList)).subscribe((response: any) => {
            this.globalHelper.CheckActionStatus(response);
            
            this.spinnerService.hide();
            this.SearchPersonDetails(1);
            if (response.IssueReserved != '') {
                this.BookAlert = ' This Acc No.: ' + response.IssueReserved + ' is reserved'
            }
        })
    }
    else {
        this.SelectAlert = 'Please select at least one book or Add new book ';
    }
}

GetTotal() {
    var TotalFineAmount = 0;
    var TotalDiscuntAmount = 0;
   
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].BookStatusID==5 || this.BookIssuedList[i].BookStatusID==3) {
            TotalFineAmount = TotalFineAmount + parseFloat(this.BookIssuedList[i].FineAmount)
            TotalDiscuntAmount = TotalDiscuntAmount + parseFloat(this.BookIssuedList[i].Discount)
        }
    }

    this.BookIssuesModel.TotalFineAmount = TotalFineAmount;
    this.BookIssuesModel.TotalDiscuntAmount = TotalDiscuntAmount;
    this.BookIssuesModel.PaidAmount = TotalFineAmount - TotalDiscuntAmount;
    this.BookIssuesModel.LibCardNo = this.PersonDetailsList.LibCardNo;

}

Reset() {
    this.BookFineID = 0;
    this.ReceiptNo = '';

    this.BookIssuesModel =
    {
        Remarks:'',
        PersonTypeID: 0,
        ClassID: 0,
        EmployeeCategoryID: 0,
        EmployeeTypeID: 0,
        SectionID: 0,
        PersonID: 0,
        BookTransactionID: 0,
        BookID: 0,
        BookSerialNo: 0,
        LibraryTypeID: 0,
        IsStaff: false,
        IsStudent: false,
        RequestStatus: 0,
        RequestByID: 0,
        BookTitle: 0,
        IsStudentStaff: 0,
        ID: 0,
        LibCardNo: '',
        IssuePeriod: 0,
        IsLosed: true,
        IsReturned: false,
        PaidAmount: 0,
        TotalDiscuntAmount: 0,
        TotalFineAmount: 0,
        BookStatusID:0,
        PaymentMode:'',
    }

    this.BookIssuesModel.PersonTypeID = 0;
    this.BookSerialNo = '';
    this.BookIssuedList = [];
    this.PersonDetailsList = {
        PersonID: 0,
        IssuePeriod: 0,
        ItemIssueLimit: 0,
        LibCardNo: '',
    };
    this.BookAlert = '';
    this.SelectAlert = '';
    this.AllBookIssuedList = [];

}





SelectAllLosed() {
    if (this.IsLosed) {
        for (var i = 0; i < this.BookIssuedList.length; i++) {
            this.BookIssuedList[i].IsReturned = false;
            this.BookIssuedList[i].IsLosed = true;
            this.IsReturned = false;
        }
    }
}

ChangeLoss(item) {
    if (item.IsLosed) {
        item.IsReturned = false;
    }
    this.IsLosed = false;
    this.Count = 0;
    for (var i = 0; i < this.BookIssuedList.length; i++) {
        if (this.BookIssuedList[i].BookStatusID==3) {
            this.Count = this.Count + 1

        }
    }
    if (this.Count == this.BookIssuedList.length) {
        this.IsLosed = true;
    }
    else {
        this.IsLosed = false;
    }
    this.ChangeReturned(item);

}
LibraryTypeModel={}

BookReturnModel =
{
    BookTransactionID: 0,
    BookID: 0,
    BankAccountID: 0,
    BankID: 0,
    BookSerialNo: '',
    PaidAmount: 0,
    LibCardNo: '',
}

GetPaymentMode() {
    this.lookupservice.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
        this.PaymentModeList = data.LookupItems;
        this.BookIssuesModel.PaymentMode = 'CASH';
    });
};



results = [];



SelectedBook(selected) {
    this.BookIssuesModel.BookSerialNo = selected.item.BookSerialNo;
}


GetAllStaff() {

    this.lookupservice.GetLookupsList('StaffName', '').subscribe((data: any) => {
        this.StaffStudentList = data.LookupItems;

    });
};

GetAllStudentStaff() {
    if (this.BookIssuesModel.IsStudentStaff == 2) {
        this.lookupservice.GetLookupsList('StudentName', '').subscribe((data: any) => {
            this.StaffStudentList = data.LookupItems;

        });
    }
    if (this.BookIssuesModel.IsStudentStaff == 1) {
        this.lookupservice.GetLookupsList('StaffName', '').subscribe((data: any) => {
            this.StaffStudentList = data.LookupItems;

        });
    }



};
BindBank() {
    this.lookupservice.GetLookupsList('BankName', '').subscribe((response: any) => {
        this.BankList = response.LookupItems;
    });
};

BindBankBranch() {
    this.lookupservice.GetLookupsList('Bank', '').subscribe((response: any) => {
        this.Bank = response.LookupItems;
        this.BookReturnModel.BankAccountID = 0;
    });
};


ngOnInit() {
    this.GetEmployee();
    this.GetEmployeeType();
    this.GetEmployeeCategory();
    this.GetPersonType();
    this.GetClass();
    this.GetStudent();
    this.GetPaymentMode();
    this.BindBank();
    this.BindBankBranch();
}

};
